import { render, staticRenderFns } from "./OfferAffPermit.vue?vue&type=template&id=700c3205&"
import script from "./OfferAffPermit.vue?vue&type=script&lang=js&"
export * from "./OfferAffPermit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports